module.exports = __webpack_public_path__ + "media/images/front/icon_02_search_gl-d7088eb9da56e7694a3e4c7bcf8137fd.png";